module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// /Users/ddcat/project/ant-design-pro-site/ant-design-pro-site/scaffold/node_modules/_core-js@2.5.3@core-js/library/modules/_is-object.js
// module id = 65
// module chunks = 0